exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".legend {\r\n    padding: 0px;\r\n    margin-bottom: 20px;\r\n    margin-left: 16px;\r\n    font-size: 21px;\r\n    color: #333;\r\n    border-bottom: 1px solid #e5e5e5;\r\n}\r\n\r\n", ""]);
